var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"app"},[(_vm.showHeader)?_c('src-components-header'):_vm._e(),_c('src-components-main',{on:{"refresh-header":function($event){return _vm.refreshHeader()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }